module.exports = __webpack_public_path__ + "static/media/striped_bar_postlapSMAP_tall.9ae79d81.svg";